import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { RestResponse } from '../models/restResponse.mode';
import { ServiceOrderTemplate, ServiceOrderTemplateDto } from '../models/service-order-template.model';

@Injectable({
  providedIn: 'root'
})
export class ServiceOrderTemplateService {
  private readonly baseUrl = `${environment.base_url}/service-order-templates`;

  constructor(private http: HttpClient) {}

  /**
   * Lista todos os templates de OS de uma empresa
   */
  getAll(companyId: number, active?: boolean): Observable<RestResponse<ServiceOrderTemplate[]>> {
    let params = new HttpParams().set('companyId', companyId.toString());
    if (active !== undefined) {
      params = params.set('active', active.toString());
    }
    return this.http.get<RestResponse<ServiceOrderTemplate[]>>(`${this.baseUrl}`, { params });
  }

  /**
   * Busca um template por ID
   */
  getById(id: number): Observable<RestResponse<ServiceOrderTemplate>> {
    return this.http.get<RestResponse<ServiceOrderTemplate>>(`${this.baseUrl}/${id}`);
  }

  /**
   * Cria um novo template
   */
  create(template: ServiceOrderTemplateDto): Observable<RestResponse<ServiceOrderTemplate>> {
    return this.http.post<RestResponse<ServiceOrderTemplate>>(`${this.baseUrl}`, template);
  }

  /**
   * Atualiza um template existente
   */
  update(id: number, template: ServiceOrderTemplateDto): Observable<RestResponse<ServiceOrderTemplate>> {
    return this.http.put<RestResponse<ServiceOrderTemplate>>(`${this.baseUrl}/${id}`, template);
  }

  /**
   * Deleta um template
   */
  delete(id: number): Observable<RestResponse<any>> {
    return this.http.delete<RestResponse<any>>(`${this.baseUrl}/${id}`);
  }

  /**
   * Ativa/desativa um template
   */
  toggleActive(id: number, active: boolean): Observable<RestResponse<any>> {
    return this.http.patch<RestResponse<any>>(`${this.baseUrl}/${id}/active`, { active });
  }
}

